/**
 * Universal image preview URL getter
 * Works with both Image and PicsImage API responses
 *
 * @param {Object} image - Image object from API response
 * @returns {string} - Preview URL or placeholder
 */
export const getImagePreviewUrl = (image) => {
  if (!image) return '/images/placeholder-portrait.jpg';

  // Standard attribute (post-refactor)
  return (
    image.preview_url ||
    // Legacy fallbacks for backward compatibility
    image.preview_image_url ||
    image.url ||
    '/images/placeholder-portrait.jpg'
  );
};

/**
 * Check if an image URL points to a JPG/JPEG file
 * Used to determine if an image should be layered over backgrounds
 * in greenscreen preview mode. JPG images don't have alpha transparency,
 * so they shouldn't be layered - only the background should be shown.
 *
 * @param {string} url - Image URL to check
 * @returns {boolean} - True if the URL ends with .jpg or .jpeg (case-insensitive)
 */
export const isJpgImage = (url) => {
  if (!url || typeof url !== 'string') return false;
  // Remove query parameters and hash fragments, then get the file extension
  const urlWithoutQuery = url.split('?')[0].split('#')[0];
  const extension = urlWithoutQuery.split('.').pop().toLowerCase();
  return ['jpg', 'jpeg'].includes(extension);
};

export default {
  getImagePreviewUrl,
  isJpgImage,
};
